import { LogoutButton } from '@/components/buttons';
import { useCurrentUser } from '@/hooks';
import { AppShell, Flex, Select, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { Outlet, useNavigate, useParams } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useGetUserCouncilChooserQuery } from './graphql.generated';
import styles from './styles.module.css';

export const CouncilChooserLayout = () => {
	const { councilId } = useParams({ from: '/council/$councilId' });
	const navigate = useNavigate();

	const { currentUser } = useCurrentUser();

	const { data } = useGetUserCouncilChooserQuery({
		variables: { id: currentUser?.id || '' },
		skip: !currentUser?.id,
	});

	const options = useMemo(() => {
		return (
			data?.user?.isCouncilStaffOf
				?.map((c) => ({
					label: c.name,
					value: c.id,
				}))
				.sort((a, b) => a.label.localeCompare(b.label)) || []
		);
	}, [data]);

	const [opened /*{ toggle }*/] = useDisclosure();

	return (
		<AppShell
			header={{ height: 60 }}
			navbar={{ width: 0, breakpoint: 'sm', collapsed: { mobile: !opened } }}
			padding="md"
		>
			<AppShell.Header>
				<Flex justify="space-between" align="center" h="100%" px="sm">
					<Flex gap="sm" align="center">
						<Text className={styles.chooserText}>Current council:</Text>
						{options.length > 1 && (
							<Select
								data={options}
								value={councilId}
								placeholder="Select council"
								disabled={options.length === 1}
								onChange={(value) => {
									if (!value) return;
									navigate({
										to: '/council/$councilId',
										params: { councilId: value },
									});
								}}
							/>
						)}
						{options.length === 1 && <Text fw="bold">{options[0].label}</Text>}
					</Flex>
					<LogoutButton />
				</Flex>
			</AppShell.Header>
			<AppShell.Main bg="curbyBg">
				<Outlet />
			</AppShell.Main>
		</AppShell>
	);
};
